import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft, FileText, Download } from "lucide-react";

export function DocsManagement() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // BYPASS AUTH FOR LOCAL PREVIEW
    setIsAuthenticated(true);
    setLoading(false);

    /*
    const checkAuth = async () => {
      try {
        const response = await fetch("/api/check_auth.php");
        const data = await response.json();
        
        if (data.authenticated) {
          setIsAuthenticated(true);
        } else {
          navigate("/login");
        }
      } catch (err) {
        console.error(err);
        // navigate("/login");
        setIsAuthenticated(true); // Force true for preview
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
    */
  }, [navigate]);

  if (loading) return <div className="text-center py-20 text-brand-primary">Caricamento...</div>;

  if (!isAuthenticated) return null;

  const internalDocs = [
    { name: "Manuale Operativo Interno 2024", date: "10/01/2024", size: "2.4 MB" },
    { name: "Procedure di Sicurezza Aggiornate", date: "15/02/2024", size: "1.1 MB" },
    { name: "Modulo Rimborsi Spese", date: "01/03/2024", size: "0.5 MB" },
    { name: "Calendario Turni Marzo 2024", date: "28/02/2024", size: "0.8 MB" },
  ];

  return (
    <div className="container mx-auto px-4 py-12 min-h-[70vh]">
      <div className="mb-8">
        <Link to="/area-riservata" className="inline-flex items-center text-brand-primary hover:underline mb-4">
          <ArrowLeft className="w-4 h-4 mr-2" /> Torna alla Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-[#004080] uppercase tracking-wider">Gestione Documenti</h1>
        <p className="text-gray-600 mt-2">Accesso ai documenti operativi riservati al personale.</p>
      </div>

      <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
        <div className="p-6 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
          <h2 className="font-semibold text-lg text-gray-800 flex items-center gap-2">
            <FileText className="w-5 h-5 text-brand-primary" />
            Documenti Disponibili
          </h2>
          <Button size="sm" variant="outline">Carica Nuovo (Admin)</Button>
        </div>
        
        <div className="divide-y divide-gray-100">
          {internalDocs.map((doc, index) => (
            <div key={index} className="p-4 hover:bg-gray-50 transition-colors flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="bg-blue-50 p-2 rounded text-blue-600">
                  <FileText className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{doc.name}</h3>
                  <p className="text-sm text-gray-500">Aggiornato il {doc.date} • {doc.size}</p>
                </div>
              </div>
              <Button variant="ghost" size="sm" className="text-brand-primary hover:text-brand-secondary hover:bg-blue-50">
                <Download className="w-4 h-4 mr-2" /> Scarica
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
